import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import esso1 from '../../../../images/esso_1_box.png';
import esso2 from '../../../../images/esso_2_box.png';
import esso3 from '../../../../images/esso_3_box.png';
import pcheart from '../../../../images/pc-heart.png';

export const Card = styled.li`
  background-color: ${themeGet('colors.white')};
  flex: none;
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid ${themeGet('colors.cta-border-grey')};

  &.feature-image-block {
    margin-top: 3.5rem;
  }

  &.pavilion-cleanliness,
  &.center {
    text-align: center;
  }

  &.right-aligned {
    text-align: right;
  }

  &.esso-splash-page {
    text-align: center;
    padding: 50px 35px;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    max-width: 375px;
    min-height: 340px;

    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &:nth-child(3n + 1) {
      background-image: url(${esso1});
    }

    &:nth-child(3n + 2) {
      background-image: url(${esso2});
    }

    &:nth-child(3n) {
      background-image: url(${esso3});
    }

    &.title-first {
      padding-bottom: 0;
    }
  }

  @media only screen and (min-width: 414px) {
    &.esso-splash-page {
      min-height: 410px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 32px;

    &.columns-4 {
      padding: 35px 30px;
    }

    &.feature-image-block {
      margin-top: 5rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 64px 40px;

    &.feature-store-block {
      flex-direction: col;
    }

    &.esso-splash-page {
      min-height: 460px;
      max-width: 415px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.esso-splash-page {
      text-align: center;
      padding: 80px 38px;
    }

    &.columns-4 {
      padding: 60px 30px;
    }

    &.feature-image-block {
      margin-top: 8rem;
    }
  }

  &.faq-category {
    padding: 32px 24px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding: 40px 32px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      padding: 48px 38px;
    }
  }
`;

export const Content = styled.div`
  ${Card}.esso-splash-page & {
    margin-bottom: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${Card}.esso-splash-page & {
      margin-bottom: 0;
    }
  }
`;

export const Header = styled.div`
  position: relative;
  margin: 0 0 10px;
  font-weight: ${themeGet('fontWeights.medium')};
  font-size: 24px;
  line-height: 36px;

  p {
    color: ${themeGet('colors.pc-red', '#E1251B')};
    margin-bottom: 25px;
  }

  h3 {
    font-size: 24px;
    line-height: 32px;
  }

  ${Card}.faq-category & {
    margin: 0 0 32px;
  }

  ${Card}.esso-splash-page & {
    min-height: auto;
    margin-top: auto;
    margin-bottom: 20px;

    img {
      min-height: 50px;
    }
  }

  ${Card}.feature-grid & {
    margin: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0 0 20px;
    line-height: 32px;

    p {
      margin-bottom: 30px;
    }

    ${Card}.feature-store-block & {
      margin-right: 64px;
    }

    ${Card}.esso-splash-page & {
      min-height: 50px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${Card}.esso-splash-page & {
      margin-top: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${Card}.faq-category & {
      margin: 0 0 37px;
    }
  }
`;

export const Body = styled.div`
  margin: 0 0 10px;

  ul {
    margin-top: 1.5rem;

    li:not(:first-child) {
      margin-top: 0;
    }

    li {
      line-height: 1.57;
      font-size: 14px;
      font-weight: ${themeGet('fontWeights.medium')};
      position: relative;
      margin: 0.75rem 0;
      padding: 0 0 0 20px;

      &::before {
        content: '• ';
        color: ${themeGet('colors.pc-red', '#E1251B')};
        transform: scale(1.75);
        margin-left: -20px;
        margin-right: 10px;
        line-height: 0;
        display: block;
        position: relative;
        top: 12px;
        width: 10px;
      }
    }
  }

  ol {
    li {
      margin: 1.5rem 0;
      font-weight: ${themeGet('fontWeights.bold')};
      p {
        color: ${themeGet('colors.main-text')};
        font-size: 18px;
        font-weight: ${themeGet('fontWeights.normal')};
      }
    }
  }

  p {
    margin-bottom: 1rem;
  }

  ${Card}.feature-image-block & {
    h3 {
      text-align: center;
      font-size: 18px;
    }
  }

  ${Card}.feature-store-block & {
    h3 {
      margin-bottom: 1.5rem;
    }
  }

  ${Card}.esso-splash-page & {
    margin: 0;

    h3 {
      margin-bottom: 15px;
      font-size: 54px;
      line-height: 46px;

      sup {
        top: 0em;

        span {
          display: inline;
          line-height: 0;
          font-size: 16px;
          margin: 0;
        }
      }

      span {
        display: block;
        font-size: 18px;
        font-weight: ${themeGet('fontWeights.bold')};
        letter-spacing: 0;
        text-align: center;
        margin-top: 12px;

        &:first-child {
          font-size: 24px;
          font-weight: ${themeGet('fontWeights.bold')};
          letter-spacing: 0;
          margin-top: 0;
          margin-bottom: 12px;
        }

        &.pts-bubble {
          margin: 0;
          font-size: 0;
          line-height: 0;
          display: inline;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0 0 20px;

    ${Card}.esso-splash-page & {
      h3 {
        font-size: 65px;

        span {
          font-weight: inherit;
          letter-spacing: inherit;

          &:first-child {
            font-weight: inherit;
            letter-spacing: inherit;
          }
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ul {
      li {
        line-height: 1.38;
        font-size: 16px;
      }
    }

    ${Card}.feature-image-block & {
      margin-top: 1.5rem;

      h3 {
        text-align: left;
      }
    }

    ${Card}.feature-store-block & {
      h3 {
        margin-bottom: 40px;
      }
    }
  }
`;

export const Footer = styled.div`
  margin: auto 0px 0px;
  display: flex;
  flex-direction: column;

  a + a {
    margin-top: 1.5rem;
  }

  p {
    font-size: 14px;
    line-height: 1.29;
    font-weight: ${themeGet('fontWeights.medium')};
  }

  a {
    display: unset;
  }

  ${Card}.faq-category & {
    margin: unset;

    a {
      span {
        border-bottom: 1px solid transparent;
      }

      &:hover {
        span {
          border-bottom: 1px solid ${themeGet('colors.pc-red', '#E1251B')};
        }
      }
    }
  }
`;

export const ProductInfo = styled.div`
  margin-top: 10px;

  p:first-child {
    margin-bottom: 0.25rem;
  }

  p.tiny {
    color: ${themeGet('colors.main-text')};
    p {
      font-size: 12px;
    }
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  ${Card}.center & {
    img {
      margin: auto;
    }
  }

  ${Card}.feature-image-block & {
    position: absolute;
    align-items: center;
    justify-content: center;
    transform: translateY(15%);
    bottom: 100%;
  }

  ${Card}.feature-store-block & {
    max-width: 142px;
    min-width: 142px;
  }

  ${Card}.pavilion-cleanliness & {
    justify-content: center;
  }

  ${Card}.esso-splash-page & {
    flex-direction: column;
    justify-content: center;

    img:nth-child(2) {
      margin-top: 15px;
    }
  }

  ${Card}.title-first & {
    flex-flow: column-reverse;

    img {
      margin-bottom: -2rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Card}.title-first & {
      img {
        margin-bottom: -30px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Card}.title-first & {
      img {
        margin-bottom: -50px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${Card}.feature-image-block & {
      align-items: unset;
      justify-content: unset;
    }

    ${Card}.feature-store-block & {
      max-width: none;
      min-width: auto;
    }

    ${Card}.pavilion-cleanliness & {
      min-height: 120px;
      max-height: 120px;

      img {
        margin: auto;
      }
    }

    /* For the ESSO Campaign page */
    ${Card}.esso-splash-page & {
      img {
        margin: auto;
      }
    }
  }
`;

export const Img = styled(Image)`
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  object-fit: contain;
  max-height: 90px;

  ${Card}.feature-store-block & {
    width: 100%;
  }

  ${Card}.esso-splash-page & {
    max-height: 180px;
  }

  ${Card}.feature-grid & {
    height: 150px;
    max-height: 150px;
  }

  ${Card}.title-first & {
    height: 250px;
    max-height: 250px;
    margin-bottom: -2rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-height: 120px;

    ${Card}.feature-store-block & {
      max-width: 142px;
    }

    ${Card}.esso-splash-page & {
      max-height: 180px;
    }

    ${Card}.feature-grid & {
      height: 250px;
      max-height: 250px;
    }

    ${Card}.title-first & {
      height: 350px;
      max-height: 350px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Card}.title-first & {
      height: 400px;
      max-height: 400px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-height: 180px;

    ${Card}.feature-store-block & {
      max-height: 32px;
      max-width: none;
      width: auto;
    }
  }
`;

export const Heading = styled.span`
  position: relative;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 130%;
  span.pc-heart {
    font-weight: inherit;
    font-size: inherit;
    &:after {
      position: absolute;
      z-index: 2;
      content: '';
      top: 75%;
      height: 33px;
      width: 47px;
      background-image: url(${pcheart});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }

  ${Card}.feature-grid & {
    margin: 2.5rem auto;
    font-size: 1.125rem;
    line-height: 130%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      span.pc-heart {
        &:after {
          height: 42px;
          width: 68px;
        }
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: 1.875rem;
      line-height: 130%;

      span.pc-heart {
        &:after {
          height: 58px;
          width: 82px;
        }
      }
    }
  }
`;
